import { Link } from "react-router-dom";
import moment from "moment";
import { FiArrowRight, FiCheckCircle, FiBookOpen } from "react-icons/fi";
import { displayCount, individualUsage, isInstitutionPlan, picksPolicy } from "./subscriptionDetails";

export default function ActiveSubscription({ plan }) {
	const institutional = isInstitutionPlan(plan);
	const { total, used, remaining } = individualUsage(plan);
	const seats = plan.seats_purchased ?? plan.number_of_seats;
	const allocations = plan.max_allocations_per_seat ?? plan.max_number_of_books;
	const picks = plan.picks_count ?? plan.current_premium_books_added;
	const unlimited = picksPolicy(plan) === "unlimited";
	const expiry = plan.expiry_date && moment(plan.expiry_date);
	const stats = institutional ? [
		{ value: displayCount(seats), label: "Seats purchased" },
		{ value: displayCount(allocations), label: "Books per student" },
		{ value: unlimited ? "Unlimited" : displayCount(picks), label: unlimited ? "Picks bank" : "Picked books" },
	] : [
		{ value: displayCount(total), label: "Premium picks" },
		{ value: displayCount(used), label: "Picks used" },
		{ value: displayCount(remaining), label: "Picks remaining" },
	];
	return (
		<section className="plans-active" aria-labelledby="current-plan-heading">
			<div className="plans-active-intro">
				<span className="plans-status"><FiCheckCircle aria-hidden="true" />Active subscription</span>
				<p className="plans-kicker">YOUR CURRENT PLAN</p>
				<h2 id="current-plan-heading">{plan.name}</h2>
				<p>{institutional ? "Institution" : "Individual"} plan{expiry?.isValid() && <> · Expires <time dateTime={expiry.format("YYYY-MM-DD")}>{expiry.format("D MMM YYYY")}</time></>}</p>
				<Link className="plans-button plans-button-light" to="/books"><FiBookOpen aria-hidden="true" />{institutional ? "Find books to allocate" : "Find your next pick"}<FiArrowRight aria-hidden="true" /></Link>
			</div>
			<div className="plans-active-details">
				<dl className="plans-stats">{stats.map(({ value, label }) => <div key={label}><dt>{label}</dt><dd className={value === "Unlimited" ? "plans-stat-word" : undefined}>{value}</dd></div>)}</dl>
				{!institutional && total > 0 && used !== null && <progress className="plans-progress" max={total} value={Math.min(used, total)} aria-label="Premium picks used" />}
				<p className="plans-usage-note">{institutional ? `${displayCount(picks)} books in your picks bank. Allocate books to students through your institution account.` : remaining === 0 ? "You’ve used all your premium picks for this plan. You can keep reading your picks while your subscription is active." : "Choose eligible subscription books from the catalogue. Free titles don’t use your premium picks."}</p>
				<div className="plans-active-links"><Link to="/my-library">Go to my library<FiArrowRight aria-hidden="true" /></Link><Link to="/my-account/subscriptions">{institutional ? "Manage seats & subscription" : "Subscription details"}<FiArrowRight aria-hidden="true" /></Link></div>
			</div>
		</section>
	);
}
